import { z } from 'zod/v3';

export const logoUrlValueSchema = z.string();

export const logoUrlUiOptionsSchema = z.object({});

export type LogoUrlValue = z.infer<typeof logoUrlValueSchema>;
export type LogoUrlUiOptions = z.infer<typeof logoUrlUiOptionsSchema>;
